import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import Artwork from '../../model/artwork';
import Image from '../../model/image';
import { getLangData, getElementFrom } from '../../services/lang';
import { getSingleArtwork } from '../../services/strapiService';

type RouteParams = {
    id: string;
};

type ArtworkDetailsState = {
    isLoading: boolean;
    artwork: Artwork | null;
    artworkFailedToLoad: boolean;
    artworkFailMessage: string;
    thumbImgSrcs: Array<string>;
    noThumbImgAvailable: boolean;
    thumbImgLoadingFailed: boolean;
    imgSrcs: Array<string>;
    noImgAvailable: boolean;
    imgLoadingFailed: boolean;
};

export default class ArtworkDetails extends Component<RouteComponentProps<RouteParams>, ArtworkDetailsState> {

    constructor(props: Readonly<RouteComponentProps<RouteParams>>) {
        super(props);
        this.state = {
            isLoading: true,
            artwork: null,
            artworkFailedToLoad: false,
            artworkFailMessage: '',
            thumbImgSrcs: [],
            noThumbImgAvailable: false,
            thumbImgLoadingFailed: false,
            imgSrcs: [],
            noImgAvailable: false,
            imgLoadingFailed: false
        };

        this.loadArtwork = this.loadArtwork.bind(this);
    }

    componentDidMount() {
        this.loadArtwork();
    }

    async loadArtwork() {
        const { id } = this.props.match.params;
        if (id === undefined) {
            this.setState({
                isLoading: false,
                artworkFailedToLoad: true,
                artworkFailMessage: 'Artwork Failed to Load'
            });
            return;
        }

        try {
            const artwork: Artwork | undefined = await getSingleArtwork(id);
            if (artwork === undefined) {
                this.setState({
                    isLoading: false,
                    artworkFailedToLoad: true,
                    artworkFailMessage: 'Artwork Failed to Load'
                });
                return;
            }
            this.setState({
                isLoading: false,
                artwork: artwork
            });
            if (artwork.originalImages.length === 0) {
                this.setState({
                    noThumbImgAvailable: true,
                    noImgAvailable: true
                });
                return;
            }
            for (let i = 0; i < artwork.originalImages.length; i++) {
                const image: Image = artwork.originalImages[i];
                const mediumImage: Image = artwork.mediumImages[i];
                if (image.url === '') {
                    this.setState({
                        noThumbImgAvailable: true,
                        noImgAvailable: true
                    });
                    return;
                }
                try {
                    const thumbImageUrl: string = `${process.env.REACT_APP_STRAPI_HOST}${mediumImage.url}`;
                    let { thumbImgSrcs } = this.state;
                    thumbImgSrcs[i] = thumbImageUrl;
                    this.setState({
                        thumbImgSrcs: thumbImgSrcs,
                        noThumbImgAvailable: false,
                        thumbImgLoadingFailed: false
                    });
                } catch (err) {
                    const { thumbImgSrcs } = this.state;
                    if (thumbImgSrcs.length === 0) {
                        this.setState({ thumbImgLoadingFailed: true });
                    }
                }
                try {
                    const imageUrl: string = `${process.env.REACT_APP_STRAPI_HOST}${image.url}`;
                    let { imgSrcs } = this.state;
                    imgSrcs[i] = imageUrl;
                    this.setState({
                        imgSrcs: imgSrcs,
                        noImgAvailable: false,
                        imgLoadingFailed: false
                    });
                } catch (err) {
                    console.error(err);
                    const { imgSrcs } = this.state;
                    if (imgSrcs.length === 0) {
                        this.setState({
                            imgLoadingFailed: true
                        });
                    }
                }
            }
        } catch (err) {
            console.error(err);
            this.setState({
                isLoading: false,
                artworkFailedToLoad: true,
                artworkFailMessage: 'err.message'
            });
        }
    }

    render() {

        if (this.state.isLoading) {
            return (
                <div className="container mb-5 d-flex justify-content-center text-center" >
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            );
        }

        const { artwork,
            artworkFailedToLoad,
            artworkFailMessage,
            thumbImgSrcs,
            noThumbImgAvailable,
            thumbImgLoadingFailed,
            imgSrcs,
            noImgAvailable,
            imgLoadingFailed } = this.state;
        const langData = getLangData();

        if (artworkFailedToLoad || artwork == null) {
            return (
                <div className="container d-flex justify-content-center align-items-center">
                    <p className="lead"><span className="ti-alert"></span> {artworkFailMessage}</p>
                </div>
            );
        }

        let image, imageModals, downloadBtn;

        if (thumbImgSrcs.length > 0) {

            if (thumbImgSrcs.length > 1) {
                image = <div id="artworkImagesCarousel" className="carousel slide" data-ride="carousel">
                    <div className="carousel-inner">
                        {thumbImgSrcs.map((tis, idx) => (
                            <div className={'carousel-item' + (idx === 0 ? ' active' : '')} key={idx}>
                                <img className="d-block w-100 cursor-enlarge" src={tis} alt="Artwork" data-toggle="modal" data-target={'#imageModal' + idx} />
                            </div>
                        ))}
                    </div>
                    <a className="carousel-control-prev" href="#artworkImagesCarousel" role="button" data-slide="prev">
                        <span className="ti-angle-left text-white" aria-hidden="true"></span>
                    </a>
                    <a className="carousel-control-next" href="#artworkImagesCarousel" role="button" data-slide="next">
                        <span className="ti-angle-right text-white" aria-hidden="true"></span>
                    </a>
                </div>;
            } else {
                image = <img className="d-block w-100 cursor-enlarge" src={thumbImgSrcs[0]} alt="Artwork" data-toggle="modal" data-target={'#imageModal0'} />;
            }

            imageModals = <div>
                {thumbImgSrcs.map((tis, idx) => {
                    return (
                        <div className="modal fade" id={'imageModal' + idx} tabIndex={-1} role="dialog" key={idx}>
                            <button type="button" className="close position-absolute top-0 right-0 text-white fw-300" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                <div className="modal-content position-relative">
                                    <img src={tis} alt="Artwork" />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div >;

        } else if (noThumbImgAvailable) {
            image = <div className="h-100 d-flex justify-content-center align-items-center">
                <p><span className="ti-image"></span> {langData.meta.noImgAvailable}</p>
            </div>;
        } else if (thumbImgLoadingFailed) {
            image = <div className="h-100 d-flex justify-content-center align-items-center">
                <p><span className="ti-alert"></span> {langData.meta.imgFailedToLoad}</p>
            </div>;
        } else {
            image = <div className="h-100 d-flex justify-content-center align-items-center">
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div >;
        }

        if (imgSrcs.length > 0) {

            downloadBtn = imgSrcs.map((is, idx) => (
                <a
                    className="btn btn-block btn-outline-dark"
                    href={is}
                    download={'susanne-klein-estate-' + artwork.regNum + '.jpeg'}
                    target="_blank"
                    rel="noopener noreferrer"
                    key={idx}
                >
                    <span className="ti-download"></span> {langData.meta.hqImg} {imgSrcs.length > 1 ? idx + 1 : ''}
                </a>
            ));

        } else if (noImgAvailable) {
            downloadBtn = <a
                className="btn btn-block btn-outline-dark disabled"
                href={imgSrcs[0]}
                download={'susanne-klein-estate-' + artwork.regNum + '.jpeg'}
                target="_blank"
                rel="noopener noreferrer"
            >
                <span className="ti-image" /> {langData.meta.noImgAvailable}
            </a>;
        } else if (imgLoadingFailed) {
            downloadBtn = <a
                className="btn btn-block btn-outline-dark disabled"
                href={imgSrcs[0]}
                download={'susanne-klein-estate-' + artwork.regNum + '.jpeg'}
                target="_blank"
                rel="noopener noreferrer"
            >
                <span className="ti-alert" /> {langData.meta.imgFailedToLoad}
            </a>;
        } else {
            downloadBtn = <div className="d-flex justify-content-center align-items-center">
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>;
        }


        return (
            <div >
                <div className="container mb-5">
                    <div className="row">
                        <div className="col-12 col-md-8 col-lg-8 col-xl-8 mb-4">
                            {image}
                        </div>

                        <div className="col-12 col-md-4 col-lg-4 col-xl-4">
                            <div className="sticky-top top-123">
                                <div className="row mb-2">
                                    <div className="col">
                                        <p className="h1 fw-300">{`#${artwork.regNum} ${artwork.title}`}</p>
                                    </div>
                                </div>

                                {ArtworkDetailEntry(langData.catalogue.typeOfObject, getElementFrom(langData.catalogue.typeOfObjectValues, artwork.typeOfObject.toLowerCase()))}
                                {ArtworkDetailEntry(langData.catalogue.date, artwork.date)}
                                {ArtworkDetailEntry(
                                    langData.catalogue.material,
                                    artwork.materials
                                        .map(m => getElementFrom(langData.catalogue.materialValues, m))
                                        .join(', ') + ' ' + langData.meta.on + ' ' + artwork.support
                                            .map(s => getElementFrom(langData.catalogue.supportValues, s))
                                            .join(', '))}
                                {ArtworkDetailEntry(langData.catalogue.measurements, artwork.height + ' x ' + artwork.width + ' cm')}

                                <div className="row mt-5">
                                    <div className="col">
                                        {downloadBtn}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {imageModals}
            </div>
        );
    }
}

function ArtworkDetailEntry(key: string, value: string) {
    return (
        <div className="row mb-3">
            <div className="col-5">
                {key}
            </div>
            <div className="col-7">
                {value}
            </div>
        </div>
    );
}

